import { styled } from '@mui/material';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';

export const AddColumnButtonContainer = styled('div')(({ theme }) => ({
  marginLeft: theme.spacing(1.5),
  marginTop: theme.spacing(5),
}));

export const InfoCardsContainer = styled('div')({
  display: 'flex',
  padding: '1rem 2.5rem',
  backgroundColor: '#f1f4f6',

  '& .MuiPaper-root': {
    flexGrow: 1,
    '&:last-child': {
      marginRight: 0,
    },
  },
});

export const StyledScalarSpreadsheet = styled(ScalarSpreadsheet)({
  '& td': {
    maxWidth: '140px',
  },
});
